'use strict';

var getDifferenceIntervals = require('./getDifferenceIntervals.cjs');

const getDifferenceIntervalsMultiple = (base, holes) => {
  return [...holes].sort((a, b) => a.start - b.start).reduce(
    (acc, hole) => {
      const last = acc[acc.length - 1];
      const rest = acc.slice(0, -1);
      if (last === void 0) {
        return acc;
      }
      return [...rest, ...getDifferenceIntervals(last, hole)];
    },
    [base]
  );
};

module.exports = getDifferenceIntervalsMultiple;
//# sourceMappingURL=getDifferenceIntervalsMultiple.cjs.map
